import { Fragment } from 'react';
import type { ArticleBlock, Lang } from '@/data/types';
import { GuideSecret } from './GuideSecret';

/** Renders the structured article body blocks (h2/h3/p/ul/steps/kv/code/callout/secret).
 *  `lang` only words the secret box's own buttons; the blocks arrive translated. */
export function ArticleBody({ blocks, lang = 'en' }: { blocks: ArticleBlock[]; lang?: Lang }) {
  return (
    <>
      {blocks.map((b, i) => {
        if (b.h2) return <h2 key={i}>{b.h2}</h2>;
        if (b.h3) return <h3 key={i}>{b.h3}</h3>;
        if (b.p) return <p key={i}>{b.p}</p>;
        if (b.ul)
          return (
            <ul key={i}>
              {b.ul.map((it, j) => (
                <li key={j}>{it}</li>
              ))}
            </ul>
          );
        if (b.steps)
          return (
            <ol key={i} className="step-list">
              {b.steps.map((it, j) => (
                <li key={j}>{it}</li>
              ))}
            </ol>
          );
        if (b.kv)
          return (
            <dl key={i} className="kvgrid">
              {b.kv.map(([k, v], j) => (
                <Fragment key={j}>
                  <dt>{k}</dt>
                  <dd>{v}</dd>
                </Fragment>
              ))}
            </dl>
          );
        if (b.code)
          return (
            <pre key={i} className="code-block">
              {b.code}
            </pre>
          );
        if (b.callout)
          return (
            <div
              key={i}
              className={`callout ${b.callout.tone || ''}`}
              dangerouslySetInnerHTML={{ __html: b.callout.html }}
            />
          );
        if (b.secret) return <GuideSecret key={i} id={b.secret.id} title={b.secret.title} lang={lang} />;
        return null;
      })}
    </>
  );
}
